import $ from 'cash-dom';
import Popup from '../../../components/popup';
import Ajax from '../../../components/ajax';
import pgFilter from './PgFilter';
import pgFilterPopupProxy from './PgFilterPopupProxy';
import animatedReadMore from '../../../components/animated-read-more';
import ScoreTooltip from "../../../components/score-tooltip";
import Utils from '../../../components/Utils';
import DateHelper from '../../../components/DateHelper';
import CallboxLoader from "../../../components/callbox-loader.js";
import spinner from '../../../components/spinner';

const METLIFE_FILTER_OPTIONS_MAX_WAIT = 8000;
const METLIFE_FILTER_OPTIONS_MAX_ATTEMPTS = 2;

$(document).ready(function() {
	const ResultsLoading = {
		_$loadingResults: $('.loading-screen'),
		_$headerBackground: $('#header-background'),
		_$progress: $('.loading-screen .loading-results-progress-value'),
		_statusElements: Array.from(document.querySelectorAll('.loading-results-status')),
		_progressInterval: null,
		_statusTimers: [],
		_currentProgress: 0,
		_targetProgress: 0,
		_compareStartedAt: 0,

		init() {
			const self = this;
			const url = new URL(window.location.href);

			if (!url.searchParams.has('form') || url.searchParams.get('form') !== 'results'
				|| !url.searchParams.has('form-data')) {
				self._$loadingResults.hide();
				return;
			}

			self._startLoader();

			Ajax.post(ajaxurl, {
				action: 'form-data-crypto-handler',
				data: url.searchParams.get('form-data'),
				job: 'decrypt',
			}, function (dataObj) {
				if (!dataObj) {
					self._stopLoader();
					return;
				}

				self._setUserData(dataObj);
				self._setStatus(0, 'completed');
				self._setStatus(1, 'active');
				self._setProgressTarget(42);
				self._compareStartedAt = Date.now();
				self._schedulePersonalizingStatus();

				if (dataObj.quote_ids) {
					Utils.setCookie('quote_ids', JSON.stringify(dataObj.quote_ids), {expires: DateHelper.tomorrow()});
				}

				Ajax.post(ajaxurl, {
					action: 'submit-pet-info-form',
					data: dataObj

				}, function (response) {
					if (!response) {
						self._stopLoader();
						return;
					}

					self._completeLoader(() => self._renderResults(response, dataObj));
				}, 'json').fail(function (err) {
					self._showError();
				});
			}, 'json').fail(function (err) {
				self._showError();
			});
		},

		_setUserData(dataObj) {
			const zipCode = this._$loadingResults.find('.results-zip-code').get(0);
			const petName = this._$loadingResults.find('.results-pet-name').get(0);

			if (zipCode) {
				zipCode.textContent = dataObj.zipCode || '';
			}

			if (petName) {
				petName.textContent = dataObj.petName || '';
			}
		},

		_startLoader() {
			this._$loadingResults.show();
			this._$headerBackground.removeClass('results-page').addClass('loading-page');
			this._setStatus(0, 'active');
			this._startProgress();
			this._setProgressTarget(16);
		},

		_stopLoader() {
			this._clearStatusTimers();
			this._clearProgressInterval();
			this._$loadingResults.hide();
			this._$headerBackground.removeClass('loading-page').addClass('results-page');
		},

		_setStatus(index, state) {
			const status = this._statusElements[index];

			if (!status) {
				return;
			}

			status.classList.remove('pending', 'active', 'completed');
			status.classList.add(state);
		},

		_schedulePersonalizingStatus() {
			this._statusTimers.push(setTimeout(() => {
				this._setStatus(1, 'completed');
				this._setStatus(2, 'active');
				this._setProgressTarget(72);
			}, 700));
		},

		_completeLoader(callback) {
			this._clearStatusTimers();
			const compareElapsed = Date.now() - this._compareStartedAt;
			const compareDelay = Math.max(0, 700 - compareElapsed);

			if (compareDelay) {
				this._statusTimers.push(setTimeout(() => {
					this._showFinalLoadingStages(callback);
				}, compareDelay));
				return;
			}

			this._showFinalLoadingStages(callback);
		},

		_showFinalLoadingStages(callback) {
			this._setStatus(0, 'completed');
			this._setStatus(1, 'completed');
			this._setStatus(2, 'active');
			this._setProgressTarget(78);

			this._statusTimers.push(setTimeout(() => {
				this._setStatus(2, 'completed');
				this._setStatus(3, 'active');
				this._setProgressTarget(94);

				this._statusTimers.push(setTimeout(() => {
					this._setStatus(3, 'completed');
					this._finishProgress();

					this._statusTimers.push(setTimeout(callback, 150));
				}, 350));
			}, 350));
		},

		_startProgress() {
			this._currentProgress = 0;
			this._targetProgress = 0;

			this._progressInterval = setInterval(() => {
				if (this._currentProgress >= this._targetProgress) {
					return;
				}

				const distance = this._targetProgress - this._currentProgress;
				this._currentProgress = Math.min(
					this._targetProgress,
					this._currentProgress + Math.max(0.4, distance * 0.08)
				);
				this._$progress.css('width', this._currentProgress + '%');
			}, 80);
		},

		_setProgressTarget(progress) {
			this._targetProgress = Math.max(this._targetProgress, progress);
		},

		_finishProgress() {
			this._currentProgress = 100;
			this._targetProgress = 100;
			this._$progress.css('width', '100%');
			this._clearProgressInterval();
		},

		_clearProgressInterval() {
			if (this._progressInterval) {
				clearInterval(this._progressInterval);
				this._progressInterval = null;
			}
		},

		_clearStatusTimers() {
			this._statusTimers.forEach((timer) => clearTimeout(timer));
			this._statusTimers = [];
		},

		_getQuoteCountdownStorageKey() {
			const url = new URL(window.location.href);
			const countdownSeed = `${url.pathname}|${url.searchParams.get('form-data') || ''}`;
			let hash = 0;

			for (let index = 0; index < countdownSeed.length; index++) {
				hash = ((hash << 5) - hash) + countdownSeed.charCodeAt(index);
				hash |= 0;
			}

			return `pg-quotes-expiry-${hash >>> 0}`;
		},

		async _initQuoteCountdown() {
			const countdown = document.querySelector('.results-page .results-save-countdown');

			if (!countdown) {
				return;
			}

			const storageKey = this._getQuoteCountdownStorageKey();
			const now = Date.now();
			let expiresAt = 0;

			try {
				expiresAt = Number(localStorage.getItem(storageKey));
			} catch (error) {
				// The countdown can still run when browser storage is unavailable.
				expiresAt = 0;
			}

			if (!expiresAt) {
				expiresAt = now + (15 * 60 * 1000);

				try {
					localStorage.setItem(storageKey, String(expiresAt));
				} catch (error) {
					// Fall back to an in-memory countdown for this page view.
				}
			}

			const secondsLeft = Math.max(0, Math.ceil((expiresAt - now) / 1000));
			countdown.dataset.timeLeft = String(Math.max(1, secondsLeft));

			const { default: Countdown } = await import('../../../components/countdown');
			Countdown.init();
		},

		async _renderResults(response, dataObj) {
			this._$loadingResults.after(response);
			const resultsPage = document.querySelector('.results-page');

			try {
				await this._initQuoteCountdown();

				if (document.querySelector('select.styleable-select')) {
					const { default: makeStyleableSelects } = await import('../../../widgets/styleable-selects');
					makeStyleableSelects();
				}

				const defaultFilters = {
					'maximum-annual-coverage': [5000],
					'reimbursement-choices': [70, 80],
					'deductible-choices': [500, 1000],
					'vendor': [''],
				};

				this._initMetlifeFilterOptions(dataObj);
				pgFilter.setDefaultFilters(defaultFilters).setDefaultSortBy('price').init();
				pgFilterPopupProxy.setDefaultFilters(defaultFilters).init();
				animatedReadMore.init();
				ScoreTooltip.init();

				$('#edit-pet-btn').on('click', function(e) {
					e.preventDefault();

					const currentUrl = new URL(window.location.href);
					currentUrl.searchParams.set('form', 'quiz');
					currentUrl.searchParams.delete('form-data');
					window.location.href = currentUrl.toString();
				});

				Alooma.applyAloomaTracking();
			} finally {
				this._stopLoader();

				if (resultsPage) {
					resultsPage.classList.remove('hidden');

                    if (CallboxLoader.hasPhones($(resultsPage))) {
                        CallboxLoader.appendScript();
                    }
				}
			}
		},

		/**
		 * The results contain only the MetLife options shown with the default filters, the rest are requested once,
		 * when the selected filters allow them (see pg-get-metlife-results).
		 * @param {Object} dataObj
		 */
		_initMetlifeFilterOptions(dataObj) {
			const $vendorsContainer = $('.vendors-container');
			const filterOptions = $vendorsContainer.data('metlife-filter-options');

			if (!Array.isArray(filterOptions) || !filterOptions.length) {
				return;
			}

			let isLoading = false;
			let isLoaded = false;
			let attempts = 0;

			$(document).on('pg-filters-applied', (e, {filters}) => {
				if (isLoading || isLoaded || attempts >= METLIFE_FILTER_OPTIONS_MAX_ATTEMPTS
					|| !filterOptions.some(options => pgFilter.matchesFilters(options, filters))) {
					return;
				}

				isLoading = true;
				attempts++;

				// PgFilter hides its spinner up to 350 ms after applying the filters
				[0, 400].forEach(delay => setTimeout(() => isLoading && spinner.show(), delay));
				const hideSpinnerTimeoutId = setTimeout(() => spinner.hide(), METLIFE_FILTER_OPTIONS_MAX_WAIT);

				Ajax.post(ajaxurl, {
					action: 'pg-get-metlife-results',
					data: dataObj,
					offset: $vendorsContainer.find('.ppc-single-vendor').length,
				}, (response) => {
					if (!response || !response.success) {
						return;
					}

					isLoaded = true;

					const template = document.createElement('template');
					template.innerHTML = response.html;
					const $quotes = $([...template.content.children]);

					$vendorsContainer.append($quotes);
					animatedReadMore.bind($quotes);
					$(document).trigger('update-score-tooltip-click-handler');
					Alooma.applyAloomaTracking();

					pgFilter._applyFilters();
					$(document).trigger('pg-sort', {sortBy: pgFilter._getCurrentSortBy()});
				}, 'json').always(() => {
					isLoading = false;
					clearTimeout(hideSpinnerTimeoutId);
					spinner.hide();
				});
			});
		},

		_showError() {
			this._stopLoader();
			const popup = new Popup();
			popup.show(tr('Sorry, some error occurred. Please, try again later.'));
		},
	};

	ResultsLoading.init();
});
